(function () {
    'use strict';

    angular
        .module('app')
        .controller('GameBundlesListController', GameBundlesListController);

    GameBundlesListController.$inject = ['API', 'alert', 'debug',];

    function GameBundlesListController(API, alert, debug) {
        var vm = this;
        vm.searchTerm = '';
        vm.page = 1;
        vm.perPage = 20;
        vm.search = search;
        vm.clearSearch = clearSearch;
        vm.listMeta = {};
        vm.loadingState = {
            bundlesIsLoading: false
        };
        vm.openRemoveModal = openRemoveModal;
        vm.loadPage = loadPage;


        activate();

        function activate() {
            loadGameBundles();
        }

        function openRemoveModal(bundle) {
            alert.confirm('remove-item').then(function () {
                API.GameBundle
                    .delete({ id: bundle.id }, {}, function () {
                        loadGameBundles();
                    }, function () {
                        alert.open('error');
                    });
            }, function () {
            });
        }

        function clearSearch() {
            vm.searchTerm = '';
            vm.page = 1;
            loadGameBundles();
        }

        function search() {
            vm.page = 1;
            loadGameBundles();
        }

        function loadPage(newPageNumber) {
            vm.page = newPageNumber;
            loadGameBundles();
        }

        function loadGameBundles() {
            var promise = null;
            if (vm.searchTerm && vm.searchTerm.length > 2) {
                promise = API.GameBundle.search({
                    'q': vm.searchTerm,
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'sort': '-created',
                }).$promise;
            } else if (vm.searchTerm.length === 0) {
                promise = API.GameBundle.get({
                    'page': vm.page,
                    'per-page': vm.perPage,
                    'sort': '-created',
                }).$promise;
            }

            if (promise) {
                vm.loadingState.bundlesIsLoading = true;
                promise.then(function (response) {
                    vm.bundles = response.items;
                    vm.listMeta = response._meta;
                    vm.loadingState.bundlesIsLoading = false;
                }, function (response) {
                    debug.log(response);
                });
            }
        }
    }
})();